import { Typography, CardContent } from "@mui/material";
import TableHeaderConfigurator, {
  HEADER_NAMES_FORM_ID,
} from "./TableHeaderConfigurator";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { FormProvider, useForm } from "react-hook-form";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import FieldLabelContext from "../../search/context/FieldLabelContext";
import { useTranslation } from "react-i18next";

const ConfigureHeaderNames = () => {
  const { t } = useTranslation(["configureHeaders", "common"]);
  const { defaultFieldLabels } = useContext(FieldLabelContext);
  const form = useForm({
    defaultValues: defaultFieldLabels,
  });
  const { formState } = form;
  const { isSubmitting, isLoading } = formState;
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <FormProvider {...form}>
      <div className="flex m-auto flex-col h-3/4">
        <Card className="flex flex-col">
          <CardHeader title={t("configureHeaders:configureHeaderNames")} />
          <CardContent className="flex-1 overflow-y-auto">
            <Typography className="pb-2" variant="body1">
              {t("configureHeaders:configureHeaderNamesDescription")}
            </Typography>
            <TableHeaderConfigurator />
          </CardContent>
          <Box className="sticky bottom-0 bg-white h-fit z-50">
            <Divider />
            <Stack className="p-2" direction="row" spacing={2}>
              <Button
                form={HEADER_NAMES_FORM_ID}
                type="submit"
                variant="contained"
                disabled={isSubmitting || isLoading}
              >
                {t("common:save")}
              </Button>
              <Button onClick={goBack} color="secondary" variant="contained">
                {t("common:cancel")}
              </Button>
            </Stack>
          </Box>
        </Card>
      </div>
    </FormProvider>
  );
};

export default ConfigureHeaderNames;
